import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import Button from '@sdk/components/primitives/Button';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Checkbox from '@sdk/components/forms/Checkbox';
import gettext from '@sdk/lang/gettext';
import styled from 'styled-components';

const ChecklistButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.white};
  &:hover {
    background-color: ${({ theme }): string => theme.colors.hoverBrand};
  }
  align-items: center;
  height: 36px;
`;

const CheckboxRow = styled(Row)`
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }
`;

const TextContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
type Props = {
  id: ID;
  title: string;
  isChecked: boolean;
  handleLocations: (id: ID, checkboxClicked: boolean) => void;
};

const LocationChecklistRow: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  title,
  isChecked,
  handleLocations,
}) => (
  <>
    <ChecklistButton
      onClick={() => {
        handleLocations(id, false);
      }}>
      <CheckboxRow>
        <Checkbox value={isChecked} onChange={() => handleLocations(id, true)} />
      </CheckboxRow>
      <TextContainer>
        <Text14 pLeft={10} themeColor={ThemeColorType.gray} semiBold>
          {gettext(title)}
        </Text14>
      </TextContainer>
    </ChecklistButton>
  </>
);

export default LocationChecklistRow;
